import { useCallback, useEffect, useRef, useState } from "react";

import PipCharacter from "../components/Pip/PipCharacter";
import { usePipOptional } from "../components/Pip/PipContext";
import { getPlatformConfig } from "../services/platformConfigService";
import NumberDrop from "./NumberDrop";
import WordDrop from "./WordDrop";
import "./Games.css";

function GamesSwitcher() {
  const [game, setGame] = useState("word");
  const switcher = (
    <div className="gm-switch" role="tablist" aria-label="Choose a game">
      <button
        type="button"
        role="tab"
        aria-selected={game === "word"}
        onClick={() => setGame("word")}
      >
        Word Drop
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={game === "number"}
        onClick={() => setGame("number")}
      >
        Number Drop
      </button>
    </div>
  );
  return game === "number"
    ? <NumberDrop gameSwitch={switcher} />
    : <WordDrop gameSwitch={switcher} />;
}

export default function Games() {
  const pip = usePipOptional();
  const [state, setState] = useState("idle");
  const [wordDropEnabled, setWordDropEnabled] = useState(false);
  const [numberDropEnabled, setNumberDropEnabled] = useState(false);
  const waveTimerRef = useRef(null);
  const outfit = pip?.outfit || null;

  useEffect(() => {
    let alive = true;
    getPlatformConfig()
      .then((cfg) => {
        if (!alive) return;
        setWordDropEnabled(cfg?.wordDropEnabled === true);
        setNumberDropEnabled(cfg?.numberDropEnabled === true);
      })
      .catch(() => {
        if (!alive) return;
        setWordDropEnabled(false);
        setNumberDropEnabled(false);
      });
    return () => {
      alive = false;
    };
  }, []);

  const handlePipClick = useCallback(() => {
    if (waveTimerRef.current) clearTimeout(waveTimerRef.current);
    setState("wave");
    waveTimerRef.current = setTimeout(() => setState("idle"), 1200);
  }, []);

  /* Word Drop alone: identical early-return to pre-Number-Drop behavior. */
  if (wordDropEnabled && !numberDropEnabled) {
    return <WordDrop />;
  }

  if (wordDropEnabled && numberDropEnabled) {
    return (
      <GamesSwitcher />
    );
  }

  if (numberDropEnabled) {
    return <NumberDrop />;
  }

  return (
    <div className="gm-page">
      <div className="gm-content">
        <button
          type="button"
          className="gm-pip-btn"
          onClick={handlePipClick}
          aria-label="Wave with Pip"
        >
          <span className="gm-pip-wrap">
            <PipCharacter size={160} state={state} outfit={outfit} interactive />
          </span>
        </button>

        <div className="gm-text-side">
          <p className="gm-headline">
            Games are
            <br />
            <em>coming soon.</em>
          </p>
          <p className="gm-hand">pip can&apos;t wait — honestly, neither can we 🍁</p>
          <p className="gm-sub">
            Mini games are on the roadmap. Earn credits, unlock perks, and climb the leaderboard. Stay
            tuned.
          </p>
        </div>
      </div>
    </div>
  );
}
